<h2 mat-dialog-title> Nuevo movimiento</h2>
<mat-dialog-content>

  <mat-tab-group class="newMovimientoTabs" animationDuration="0ms">
    <mat-tab>
      <ng-template mat-tab-label><mat-icon class="tab-icon" color="primary">info</mat-icon>Información</ng-template>
      <mat-card class="cardInfo">
        @if (showProgressBar) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        <form [formGroup]="form">
          <mat-form-field class='formField'>
            <mat-label>Tipo</mat-label>
            <mat-select formControlName="tipo" [(value)]="tipo" required>
              <mat-option value="cambio">Cambio</mat-option>
              <mat-option value="entrega">Entrega</mat-option>
              <mat-option value="retirada">Retirada</mat-option>
            </mat-select>
            <mat-error>Debes seleccionar un tipo.</mat-error>
          </mat-form-field>
          <div class="conteiners">
            @if (tipo === 'entrega' || tipo === 'cambio') {
              <mat-form-field [ngClass]="tipo === 'cambio' ? 'formField50' : 'formField'">
                <mat-label>Entregar Cont.</mat-label>
                <mat-select formControlName="contenedorEntrega" required>
                  <input placeholder="Buscar..." (keyup)="filterSelect_ContenedoresEntrega($event.target.value)" class="inputSelectSearch">
                  <mat-option value=-1>Sin contenedor</mat-option>
                  @for (contenedor of contenedoresEntrega; track contenedor) {
                    <mat-option [value]="contenedor.id">{{contenedor.matricula}}</mat-option>
                  }
                </mat-select>
                <mat-error>Debes seleccionar un contenedor.</mat-error>
              </mat-form-field>
            }
            @if (tipo === 'retirada' || tipo === 'cambio') {
              <mat-form-field [ngClass]="tipo === 'cambio' ? 'formField50' : 'formField'">
                <mat-label>Retirar Cont.</mat-label>
                <mat-select formControlName="contenedorRetirada" required>
                  <input placeholder="Buscar..." (keyup)="filterSelect_ContenedoresRetirada($event.target.value)" class="inputSelectSearch">
                  <mat-option value=-1>Sin contenedor</mat-option>
                  @for (contenedor of contenedoresRetirada; track contenedor) {
                    <mat-option [value]="contenedor.id">{{contenedor.matricula}}</mat-option>
                  }
                </mat-select>
                <mat-error>Debes seleccionar un contenedor.</mat-error>
              </mat-form-field>
            }
          </div>
          <mat-form-field class='formField'>
            <mat-label>Fecha</mat-label>
            <div (click)="fechaPicker.open()">
              <input matInput [matDatepicker]="fechaPicker" (dateChange)="dateChange($event)" formControlName="fecha" disabled placeholder="Fecha" required>
            </div>
            <mat-datepicker-toggle matSuffix [for]="fechaPicker"></mat-datepicker-toggle>
            <mat-datepicker touchUi #fechaPicker disabled="false"></mat-datepicker>
          </mat-form-field>
          <mat-form-field class='formField'>
            <mat-label>Nº Albarán</mat-label>
            <input matInput type="number" placeholder="Nº Albarán" formControlName="albaran" required>
            <mat-error>Debes poner un Nº de Albarán.</mat-error>
          </mat-form-field>
          <mat-form-field class='formField'>
            <mat-label>Cliente</mat-label>
            <input matInput placeholder="Cliente" formControlName="cliente" required>
            <mat-error>Debes escribir el cliente.</mat-error>
          </mat-form-field>
          <mat-form-field class='formField'>
            <mat-label>Observaciones</mat-label>
            <input matInput placeholder="Observaciones" formControlName="observaciones">
          </mat-form-field>
        </form>
      </mat-card>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label><mat-icon class="tab-icon" color="primary">pin_drop</mat-icon>GPS</ng-template>
      <app-gps-locator [latitud]="latitud" [longitud]="longitud" (newLatitudEvent)="newLatitudEvent($event)" (newLongitudEvent)="newLongitudEvent($event)"></app-gps-locator>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label><mat-icon class="tab-icon" color="primary">photo_library</mat-icon>Galería</ng-template>
      <div class="infoBlock">
        <p> Para poder subir imágenes debes guardar el movimiento primero.</p>
        <button mat-raised-button (click)="save(true)" color="primary">Guardar y modificar</button>
      </div>
    </mat-tab>
  </mat-tab-group>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-raised-button (click)="save(false)" color="primary">Guardar</button>
</mat-dialog-actions>
